if (!customElements.get("shoppable-video-cover")) {
  customElements.define(
    "shoppable-video-cover",
    class ShoppableVideoCover extends HTMLElement {
      constructor() {
        super();
        this.isCoverVisible = true;
        this.userInitiatedPlay = false;
        this.handleCoverClick = this.handleCoverClick.bind(this);
        this.handleVideoClick = this.handleVideoClick.bind(this);
        this.handleVideoPlay = this.handleVideoPlay.bind(this);
        this.handleRewindClick = this.handleRewindClick.bind(this);
        this.handleControlClick = this.handleControlClick.bind(this);
      }

      connectedCallback() {
        this.media = this.querySelector(".shoppable-video-custom__media");
        this.cover = this.querySelector(".shoppable-video-custom__cover");
        this.video = this.querySelector("video");
        this.controlButton = this.closest("shoppable-video")?.querySelector(
          ".shoppable-video__control-button",
        );
        this.rewindButtons = this.closest("shoppable-video")?.querySelectorAll(
          ".shoppable-video__rewind-button",
        );

        if (!this.media || !this.cover || !this.video) return;

        this.video.pause();
        this.video.muted = true;
        this.media.classList.remove("shoppable-video-custom__media--playing");
        this.syncControlButton();

        this.cover.addEventListener("click", this.handleCoverClick);
        this.video.addEventListener("click", this.handleVideoClick);
        this.video.addEventListener("play", this.handleVideoPlay);
        this.controlButton?.addEventListener("click", this.handleControlClick, {
          capture: true,
        });

        this.rewindButtons?.forEach((button) => {
          button.addEventListener("click", this.handleRewindClick, {
            capture: true,
          });
        });
      }

      disconnectedCallback() {
        this.cover?.removeEventListener("click", this.handleCoverClick);
        this.video?.removeEventListener("click", this.handleVideoClick);
        this.video?.removeEventListener("play", this.handleVideoPlay);
        this.controlButton?.removeEventListener(
          "click",
          this.handleControlClick,
          { capture: true },
        );
        this.rewindButtons?.forEach((button) => {
          button.removeEventListener("click", this.handleRewindClick, {
            capture: true,
          });
        });
      }

      syncControlButton() {
        if (!this.controlButton) return;

        const isPlaying =
          !this.isCoverVisible &&
          !this.video.paused &&
          !this.video.ended;

        this.controlButton.classList.toggle(
          "shoppable-video__control-button--play",
          isPlaying,
        );
        this.controlButton.classList.toggle(
          "shoppable-video__control-button--pause",
          !isPlaying,
        );
      }

      handleControlClick(e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.isCoverVisible || this.video.paused || this.video.ended) {
          this.showVideo();
        } else {
          this.showCover();
        }
      }

      handleRewindClick() {
        if (!this.isCoverVisible) return;

        this.isCoverVisible = false;
        this.userInitiatedPlay = true;
        this.media.classList.add("shoppable-video-custom__media--playing");
        this.video.muted = false;
        this.syncControlButton();
      }

      handleCoverClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.showVideo();
      }

      handleVideoClick(e) {
        if (!this.media.classList.contains("shoppable-video-custom__media--playing")) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        this.showCover();
      }

      handleVideoPlay() {
        if (this.isCoverVisible && !this.userInitiatedPlay) {
          this.video.pause();
          return;
        }

        this.syncControlButton();
      }

      showVideo() {
        this.isCoverVisible = false;
        this.userInitiatedPlay = true;
        this.media.classList.add("shoppable-video-custom__media--playing");
        this.video.muted = false;
        this.video.play().catch(() => {});
        this.syncControlButton();
      }

      showCover() {
        this.isCoverVisible = true;
        this.userInitiatedPlay = false;
        this.video.pause();
        this.video.muted = true;
        this.media.classList.remove("shoppable-video-custom__media--playing");
        this.syncControlButton();
      }
    },
  );
}
